import type { ComponentType } from 'react';
import type { LucideProps } from 'lucide-react';
import { Container, Scale, Truck } from 'lucide-react';
import { useAuthStore } from '../store/authStore';

export type ModuleEntry = {
  key: 'collections' | 'skip' | 'weighbridge';
  label: string;
  description: string;
  icon: ComponentType<LucideProps>;
  to: string;
};

const ALL_MODULES: ModuleEntry[] = [
  {
    key: 'collections',
    label: 'Collections',
    description: 'Manage scrap bookings and collections',
    icon: Truck,
    to: '/collections/dashboard',
  },
  {
    key: 'skip',
    label: 'Skip Manager',
    description: 'Jobs, enquiries and stock management',
    icon: Container,
    to: '/skip/dashboard',
  },
  {
    key: 'weighbridge',
    label: 'Weighbridge',
    description: 'Weighbridge ticketing and kiosk',
    icon: Scale,
    to: '/weighbridge/dashboard',
  },
];

const ACCESSIBLE_ROLES = new Set(['staff', 'manager', 'admin']);

export function useAccessibleModules(): ModuleEntry[] {
  const role = useAuthStore((s) => s.user?.role);
  if (!role || !ACCESSIBLE_ROLES.has(role)) return [];
  return ALL_MODULES;
}
